import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22leaflet-serif.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../../node_modules/@fontsource/source-serif-4/files/source-serif-4-latin-600-normal.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22,%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22Georgia%22,%22Times%20New%20Roman%22,%22serif%22],%22adjustFontFallback%22:%22Times%20New%20Roman%22}],%22variableName%22:%22leafletSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'leafletSerif', 'leafletSerif Fallback', Georgia, Times New Roman, serif",
        fontWeight: 600,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
